import { CoreEvents } from "@tv4/avod-web-player-common";
import { useEffect } from "react";
export default function useSkinVisibilityChangeEvent(core, visible) {
    useEffect(() => {
        core.emitCoreEvent(CoreEvents.SKIN_VISIBILITY_CHANGE, {
            visible,
        });
    }, [core, visible]);
}
